type CurrencyType = 'dollar' | 'euro' | 'tix'

type CurrencyConfigType = {
  format: (total: string) => string
  formatter: Intl.NumberFormat
}

const PLACEHOLDER = ' - .- -'
const FORMATTER_OPTIONS: Intl.NumberFormatOptions = { maximumFractionDigits: 2, minimumFractionDigits: 2 }

const CONFIG: Record<CurrencyType, CurrencyConfigType> = {
  dollar: { format: (total) => `$${total}`, formatter: new Intl.NumberFormat('en-US', FORMATTER_OPTIONS) },
  euro: { format: (total) => `${total} €`, formatter: new Intl.NumberFormat('de-DE', FORMATTER_OPTIONS) },
  tix: { format: (total) => `${total} TIX`, formatter: new Intl.NumberFormat('en-US', FORMATTER_OPTIONS) },
}

export const formatPrice = (price?: number, currency: CurrencyType = 'dollar') => {
  const { format, formatter } = CONFIG[currency]
  const total = price && price > 0 ? formatter.format(price) : PLACEHOLDER
  return format(total)
}
